// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eb570f4f","867":"d996e247"}[chunkId] + ".chunk.js";
};